<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="我的会员卡" />
    </van-sticky>
		<div class="search-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="(item,index) in userInfo.userVipRecords" :key="index" :class="'testing' + item.testingId" class="flex-row-between">
          <div>
            <!-- 信息 -->
            <div class="flex-row-between" style="padding-right: 16px">
              <div class="baseinfo flex-row-start">
                <div class="font-bigger">{{ item.testingName }}</div>
              </div>
            </div>
            <!-- 按钮 -->
            <div class="bottom flex-row-between">
              <div class="state">有效期至：{{ item.endTime }}</div>
              <div class="flex-row-end">
                <div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-col-center">
            <img
            v-if="item.valid"
            class="valid"
            src="../../../assets/images/VIP-有效.png"/>
            <img
            v-else
            class="no-valid"
            src="../../../assets/images/已失效.png"/>
          </div>
        </div>
      </van-list>
		</div>
  </div>
</template>
<script>
import { isWeiXin } from '@/utils/tools'
import { auth, h5Buy } from '@/api/testing-record'
import { fetchUserInfo } from '@/api/user'
export default {
  data() {
    return {
      typeBg: {
        'User': '../../../assets/images/user-bg.png',
        'Student': '../../../assets/images/student-bg.png'
      },
      userInfo: {},
      searchValue: '',
      offset: 100,//滚动条与底部距离小于 offset 时触发load事件，默认300
      pageNum: -1, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: true, // 滚动加载中
      finished: true, // 滚动加载完成
      tabData: []
    };
  },
  filters: {
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    init() {
      this.$nextTick(() => {
        fetchUserInfo().then(res => {
          this.userInfo = res
          this.finished = true
          this.loading = false
        })
      })
    },
    //点击键盘上的搜索/回车按钮后触发
    handleEnterSearchInfors(val) {
      console.log(val);
    },
    handleButtonSearchInfors() {
    },
    // 滚动加载更多
    onLoad() {
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.search-container {
  padding: 0.66667rem;
  background-repeat: no-repeat;
  background-size: 100%;
}
.van-search {
  border-radius: 20px;
  /deep/ .van-search__content {
    background-color: #31607b;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #999;
  }
  /deep/ input::-moz-input-placeholder {
    color: #999;
  }
  /deep/ input::-ms-input-placeholder {
    color: #999;
  }
  /deep/ .van-field__control {
    color: #c28831;
  }
}
.van-search__action {
  background-image: radial-gradient(#d8ba79, #c28831);
  padding: 0 32px;
  margin: 0 20px 0 0;
  color: #1b2026;
  border-radius: 20px;
  div {
    font-size: 30px;
  }
}
.search-list {
  padding: 0 40px 40px 40px;
  .testing6 {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/user-bg.png');
  }
  .testing5 {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/student-bg.png');
  }
  .valid {
    margin-right: 24px;
    width: 80px;
    height: 80px;
  }
  .no-valid {
    margin-right: 24px;
    width: 120px;
    height: 80px;
  }
}
.custom-title {
  color: #999999;
}
.name {
  padding: 24px 24px 0 24px;
}
.content {
  color: #999!important;
  margin-top: 16px;
  padding-left: 24px;
  div {
    color: #999!important;
    margin-top: 8px;
  }
}
.state {
  font-weight: bold;
  color: #ff9e19;
}
.bottom {
  font-size: .32rem;
  padding: 24px;
}
.baseinfo {
  margin-top: 24px;
  padding-left: 24px;
  .sex {
    width: 24px;
    height: 24px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
.detailinfo {
  padding-left: 24px;
  padding-top: 8px;
}
.headimg {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.font-bigger {
  padding-right: 0px;
}
.font-intro {
  padding-right: 16px;
}
</style>